import {remCalc} from '_themeUtils'

const commonTextStyles = {
    textStyle: 'paragraphLg',
    fontWeight: 400,
    letterSpacing: remCalc(0.7),
}

const wishlistSizeModal = {
    WishlistSizeModal: {
        baseStyle: () => ({
            body: {
                mb: 'spacing.14',
            },
            title: {
                ...commonTextStyles,
                textTransform: 'uppercase',
            },
            description: {
                ...commonTextStyles,
            },
            footer: {
                justify: 'center',
            },
            closeButton: {
                px: 'spacing.8',
                w: {base: 'full', md: 'fit-content'},
            },
        }),
    },
}

export default wishlistSizeModal
